import { render, staticRenderFns } from "./NewsPopup.vue?vue&type=template&id=b7ab7bcc&scoped=true"
import script from "./NewsPopup.vue?vue&type=script&lang=js"
export * from "./NewsPopup.vue?vue&type=script&lang=js"
import style0 from "./NewsPopup.vue?vue&type=style&index=0&id=b7ab7bcc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ab7bcc",
  null
  
)

export default component.exports